const awsExports = {
  REGION: 'us-east-1',
  USER_POOL_ID: 'us-east-1_5czNiKD7k',
  USER_POOL_APP_CLIENT_ID: '2pr19vlg9gdpmfkgj0dmk8jirj'
};

export default awsExports;
